import { render, staticRenderFns } from "./loginBySms.vue?vue&type=template&id=2af14beb&"
import script from "./loginBySms.vue?vue&type=script&lang=js&"
export * from "./loginBySms.vue?vue&type=script&lang=js&"
import style0 from "./loginBySms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports